// extracted by css-extract-rspack-plugin
export default {"cls1":"LoswpTabsHero-cls1_v3N","cls2":"LoswpTabsHero-cls2_eGk LoswpTabsHero-cls1_v3N","size-v2":"LoswpTabsHero-size-v2_ofv"};